// extracted by mini-css-extract-plugin
export var fadeIn = "_98-0";